<template>
  <div>
    <topic-filter-link :filterLayout="filterLayout" :filterData="filterSet.filter" :paginationData="filterSet.page" :cateData="cateData"></topic-filter-link>
    <topic-list-link :listLayout="listLayout" :paginationData="filterSet.page" :topicData="List" :cateData="cateData"></topic-list-link>
    <pagination-link :paginationLayout="paginationLayout" :paginationData="filterSet.page"
                     :listLength="List.length"></pagination-link>
  </div>
</template>

<script>
import PaginationLink from "@/components/topic/PaginationLink";
import TopicFilterLink from "@/components/topic/TopicFilterLink";
import TopicListLink from "@/components/topic/TopicListLink";
import filterMixins from "@/mixins/filterMixins";
import listMixins from "@/mixins/listMixins";
import alertMixins from "@/mixins/alertMixins";
import topicUtil from "@/components/topic/topicUtil";
import EventBus from "@/utils/event-bus";
import util from "@/mixins/util";

import DeleteClass from "@/mixins/deleteClass";

const {filterConfig} = topicUtil;

export default {
  name: "TopicListComponent",
  mixins: [filterMixins,listMixins,alertMixins,topicUtil],
  components: {TopicListLink, TopicFilterLink, PaginationLink},
  provide() {
    return {
      setPage: this.setPage,
      setFilter: this.setFilter,
      topicListSetData: this.setData,
      contentListDelete: this.runDeleteConfirm,
    }
  },
  inject: ['changeLoading'],
  props: {
    topicType: {default: ''},
  },
  data() {
    return {
      listLayout: '',
      filterLayout: '',
      paginationLayout: '',

      getFunc: '',
      listApiParamSet: {},
      pageRow: 10,

      deleteFunc: '',
      deleteApiParamsSet: {},
      deleteSuccessType: 1,
      deleteFailTypes: {},
      keyName: '',

      deleteIndex: 0,
      DeleteClass: null,

      isCategory : false,
      getCategoryFunc :'',
      categoryApiParamsSet:{},
      cateData :{},
    }
  },
  created() {
    this.setFilterConfig(filterConfig)
    this.setParserType('url', this.$route.fullPath);
    this.initConfig();
    this.newDeleteClass();
  },
  mounted() {
    this.getList(true);
  },
  beforeDestroy() {
  },
  destroyed() {},
  computed: {
  },
  methods: {
    setData(type, value) {
      this[type] = value;
    },
    initConfig() {
      let config = this.returnTopicConfig(this.topicType)
      this.listLayout= config.listLayout;
      this.filterLayout = config.filterLayout;
      this.paginationLayout = config.paginationLayout;
      this.getFunc = config.getFunc;
      this.listApiParamSet = config.listApiParamSet;

      this.isCategory = config.isCategory;
      this.getCategoryFunc = config.getCategoryFunc;
      this.categoryApiParamsSet = config.categoryApiParamsSet;

      this.deleteFunc = config.deleteFunc;
      this.deleteApiParamsSet = config.deleteApiParamsSet;
      this.deleteSuccessType = config.deleteSuccessType;
      this.deleteFailTypes = config.deleteFailTypes;

      this.keyName = config.keyName;

      let listOptions = {
        url : this.$api.$online[this.getFunc],
        defaultParams : this.listApiParamSet
      }

      this.initList('api', listOptions);

      if(this.isCategory){
        this.getCategory();
      }
    },

    getCategory() {
      let params = Object.assign({}, this.categoryApiParamsSet);
      this.$api.$online[this.getCategoryFunc](params).then(res => res.Data.Result).then(res => {
        this.cateData = res.List
      })
    },

    newDeleteClass() {
      let deleteOptions = {
        func: this.$api.$online[this.deleteFunc],
        apiParamSet: this.deleteApiParamsSet,
        keyName: this.keyName,
        successType: this.deleteSuccessType,
        errorTypes: this.deleteFailTypes,
        afterFunc: this.deleteAfterFunc,
      }
      this.DeleteClass = new DeleteClass(deleteOptions);
    },
    runDeleteConfirm() {
      if (this.selectArr.length === 0) {
        this.errorAlert('목록을 선택해주세요.');
        return false;
      }
      this.createConfirm({
        content: '정말 삭제하시겠습니까?',
        confirm: () => {
          this.deleteIndex = 0;
          this.deleteLastIndex = this.selectArr.length - 1;
          this.runDelete();
        }
      })
    },
    runDelete() {
      this.changeLoading(true);
      this.DeleteClass.runDelete(this.selectArr[this.deleteIndex]);
    },
    deleteAfterFunc() {
      if (this.deleteIndex < this.deleteLastIndex) {
        this.deleteIndex = this.deleteIndex + 1;
        this.runDelete()
      } else {
        this.changeLoading(false);
        this.createAlert({
          content: '삭제되었습니다.',
          hide: () => {
            this.deleteIndex = 0;
            this.getList();
          }
        })
      }
    },
  },
  watch: {},
}
</script>

<style scoped>

</style>
